export const logout = () => {
    localStorage.removeItem('tokenStorage');
    if(window.location.hostname === "localhost"){
        window.location.href = "http://localhost:3002/auth/login";
    }else{
        window.location.href = "https://admin.gryb.appandwebstudio.com.br/auth/login";
    }
}